<main id="main-content" class="ds-product-page account-page">
  <header class="account-hero">
    <p class="ds-eyebrow">Private account</p>
    <h1>Your assessment history</h1>
    <p>
      Sign in without a password to keep future IQLabTest results together. Taking a test
      anonymously remains available.
    </p>
  </header>

  @if (loading()) {
    <ds-state kind="loading" title="Loading your account" message="Checking your secure session." />
  } @else if (!user()) {
    <section dsCard class="signin-card" aria-labelledby="signin-title">
      <h2 id="signin-title">Email me a secure sign-in link</h2>
      <p>
        No password is required. The link is single-use and sent through our email delivery worker.
      </p>
      @if (sent()) {
        <ds-alert title="Check your inbox"
          ><p>
            If an account can be created for that address, a sign-in link is on its way.
          </p></ds-alert
        >
      } @else {
        <form (ngSubmit)="sendLink()">
          <label for="account-email">Email address</label>
          <input
            dsInput
            id="account-email"
            type="email"
            autocomplete="email"
            [ngModel]="email()"
            (ngModelChange)="email.set($event)"
            name="email"
            required
          />
          <button dsButton type="submit">Send secure link</button>
        </form>
      }
      @if (error()) {
        <p class="field-error" role="alert">{{ error() }}</p>
      }
      <p class="privacy-note">
        Only assessments started while you are signed in appear here. We do not attach earlier
        anonymous results automatically.
      </p>
    </section>
  } @else {
    <section class="account-summary" aria-label="Account summary">
      <div>
        <span>Signed in as</span><strong>{{ user()?.email }}</strong>
      </div>
      <div>
        <span>Saved assessments</span><strong>{{ history().length }}</strong>
      </div>
      <button dsButton variant="secondary" type="button" (click)="logout()">Sign out</button>
    </section>
    @if (history().length) {
      <section dsCard class="history-card" aria-labelledby="history-title">
        <h2 id="history-title">Completed assessments</h2>
        <div class="history-list">
          @for (item of history(); track item.testId) {
            <article>
              <div>
                <strong>{{ item.candidateName }}</strong
                ><span>{{ item.completedAtUtc | date: 'mediumDate' }}</span>
              </div>
              <div class="history-score">
                <strong>{{ item.estimate }}</strong
                ><span>Range {{ item.rangeLow }}&ndash;{{ item.rangeHigh }}</span>
              </div>
              <nav aria-label="Result actions">
                <a [href]="'/verify/' + item.testId">Verify</a
                ><a [href]="certificateUrl(item.testId)">Certificate</a>
              </nav>
            </article>
          }
        </div>
      </section>
    } @else {
      <ds-state
        kind="empty"
        title="No saved assessments yet"
        message="Start a new test while signed in and it will appear here."
      >
        <a dsButton href="/">Start an assessment</a>
      </ds-state>
    }
  }
</main>
